// extracted by mini-css-extract-plugin
export default {"image":"styles-module__image___kiHQE","trusted":"styles-module__trusted___VDiCg","featured":"styles-module__featured___E6dbq","members":"styles-module__members___atjLw"};